module.exports = __webpack_public_path__ + "static/media/whythinkvideo.4c4237d4.png";